/**
 * @author Harish.R <harish.r@314ecorp.com>
 * @description OpenStripePortal Button
 */
import _ from 'lodash';
import { Button, ButtonProps, ModalFuncProps, App } from 'antd';

import AppEvents, { Events } from '@veritable/common/utils/appEvents';
import useOpenPaymentPortal from 'hooks/admin/mutate/useOpenPaymentPortal';
import { MODAL_TYPES } from '../modal';

const LABELS = {
	failure: 'Update Payment Method',
	portal: 'Go to Stripe customer portal',
};

const REDIRECT_MESSAGE = 'Redirected to Stripe Customer Portal';

const MODAL_PROPS: ModalFuncProps = {
	...MODAL_TYPES.warning,
	width: 500,
	content: 'There was some error loading Stripe customer portal. Please reload the page and try again!',
};

/**
 * OpenStripePortal
 */
const OpenStripePortal: React.FC<{ buttonType?: 'failure' | 'portal' } & ButtonProps> = ({ buttonType = 'portal', ...props }) => {
	const { modal } = App.useApp();
	const { mutate, isPending } = useOpenPaymentPortal();

	const openPortal = () => {
		mutate(undefined, {
			onSuccess: (stripeURL) => {
				// show error modal if no stripeURL
				if (!stripeURL) {
					modal.error(MODAL_PROPS);
				}
				// redirect to stripe portal if valid stripeURL
				else {
					AppEvents.publish(Events.Success, REDIRECT_MESSAGE);
					// open in new tab
					window.open(stripeURL, '_blank', 'noopener,noreferrer');
				}
			},
		});
	};

	return (
		<Button {...props} loading={isPending} onClick={openPortal}>
			{_.get(LABELS, buttonType as string, LABELS.portal)}
		</Button>
	);
};

export default OpenStripePortal;
